import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53522542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "field lg:col-2 md:col-2 sm:col-2" }
const _hoisted_3 = { class: "day h-full flex align-items-center lg:justify-content-center" }
const _hoisted_4 = { class: "lg:col-10" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "field lg:col-4 md:col-12 sm:col-12" }
const _hoisted_9 = { class: "h-full flex align-items-center justify-content-start" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2 col-4 ml-2" }, "から", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_13 = { class: "grid" }
const _hoisted_14 = { class: "field lg:col-4 md:col-12 sm:col-12" }
const _hoisted_15 = { class: "h-full flex align-items-center justify-content-start" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2 col-4 ml-2" }, "から", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "h-full flex lg:justify-content-start pt-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "monday_afternoon_end" }, "休業日", -1))

import { reactive, watch, withDefaults, ref, computed } from "vue";
import { get, MaybeRefOrGetter, set } from "@vueuse/core";
import { dayOfWeek } from "@/clinic/typings/enums/day-of-week";
import { Rule, Rules, ValidateError } from "async-validator";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import Toast from "primevue/toast";
import { after, range } from "lodash";
import { useToast } from "primevue/usetoast";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import commonTimeWorkRules from "@/clinic/validates/validate.time-work";
type IForm = {
  name: string;
  isSpecified?: boolean;
  data: any;
};

type IFormRuleValidation = {
  startTimeMorning: number;
  startTimeMorningMinute: number;
  endTimeMorning: number;
  startTimeAfterNoon: number;
  endTimeAfterNoon: number;
};

type IFieldValidator = {
  [key: string]: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'date',
  props: {
    name: null,
    isSpecified: { type: Boolean, default: false },
    data: null
  },
  emits: ["validateFn"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { name: string, isSpecified: boolean, data: any };

const toast = useToast();




const morningStartMinute = ref({ name: "0分", value: "0" });
const morningEndMinute = ref({ name: "0分", value: "0" });
const afternoonStartMinute = ref({ name: "0分", value: "0" });
const afternoonEndMinute = ref({ name: "0分", value: "0" });

const formDataInit = computed(() => {
  const morning_shift_start_hour = parseInt(get(props.data?.[`${props["name"]}_morning_start`])).toString();
  if (get(props.data?.[`${props["name"]}_morning_start`])?.length > 3) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_morning_start`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_morning_start`])?.split(":")[1].toString(),
    };
    set(morningStartMinute, temp);
  }

  const morning_shift_end_hour = parseInt(get(props.data?.[`${props["name"]}_morning_end`]), 10).toString();
  if (get(props.data?.[`${props["name"]}_morning_end`])?.length > 3) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_morning_end`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_morning_end`])?.split(":")[1].toString(),
    };
    set(morningEndMinute, temp);
  }

  const afternoon_shift_start_hour = parseInt(get(props.data?.[`${props["name"]}_afternoon_start`])).toString();
  if (get(props.data?.[`${props["name"]}_afternoon_start`])?.length > 3) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_afternoon_start`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_afternoon_start`])?.split(":")[1].toString(),
    };
    set(afternoonStartMinute, temp);
  }

  const afternoon_shift_end_hour = parseInt(get(props.data?.[`${props["name"]}_afternoon_end`])).toString();
  if (get(props.data?.[`${props["name"]}_afternoon_end`])?.length > 3) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_afternoon_end`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_afternoon_end`])?.split(":")[1].toString(),
    };
    set(afternoonEndMinute, temp);
  }

  return {
    [`${props["name"]}_off`]: get(props.data?.[`${props["name"]}_off`]),
    [`${props["name"]}_morning_start`]: morning_shift_start_hour,
    [`${props["name"]}_morning_start_minute`]: morningStartMinute,
    [`${props["name"]}_morning_end`]: morning_shift_end_hour,
    [`${props["name"]}_morning_end_minute`]: morningEndMinute,
    [`${props["name"]}_afternoon_start`]: afternoon_shift_start_hour,
    [`${props["name"]}_afternoon_start_minute`]: afternoonStartMinute,
    [`${props["name"]}_afternoon_end`]: afternoon_shift_end_hour,
    [`${props["name"]}_afternoon_end_minute`]: afternoonEndMinute,
  };
});

const form = reactive(formDataInit.value);

const hours = [...Array(24).keys()].map(hour => {
  return {
    name: hour + "時",
    value: hour.toString(),
  };
});

const minutes = [...range(0, 60, 5)].map(minute => {
  return {
    name: minute + "分",
    value: minute.toString(),
  };
});

const initValidation = (value: IFieldValidator | any, rules: MaybeRefOrGetter<Record<string, Rule | Rules>>) =>
  useAsyncValidator(value, rules, { validateOption: { suppressWarning: true } });

const validate = async (fieldName?: string) => {
  const fieldTime = {
    startTimeMorning:
      parseInt(get(form[props["name"] + "_morning_start"])) + parseInt(get(morningStartMinute).value) / 60,
    endTimeMorning: parseInt(get(form[props["name"] + "_morning_end"])) + parseInt(get(morningEndMinute).value) / 60,
    startTimeAfterNoon:
      parseInt(get(form[props["name"] + "_afternoon_start"])) + parseInt(get(afternoonStartMinute).value) / 60,
    endTimeAfterNoon:
      parseInt(get(form[props["name"] + "_afternoon_end"])) + parseInt(get(afternoonEndMinute).value) / 60,
  } as IFormRuleValidation;
  const formRules = commonTimeWorkRules(fieldTime);
  const [value, rules] = fieldName
    ? [{ [fieldName]: fieldTime[fieldName] }, { [fieldName]: formRules[fieldName] }]
    : [fieldTime, formRules];

  const { pass: formPass } = initValidation(form, formRules);
  const { execute } = initValidation(value, rules);
  const { errorFields: fErrorFields, errors: fErrors } = await execute();
  set(errorFields, get(fErrorFields));
  set(pass, get(formPass));
  set(errors, get(fErrors));
  const fieldNames = Object.keys(fieldTime);
  fieldNames.forEach(fieldName => {
    if (errorFields.value[fieldName]) {
      const errorMessage = (errorFields.value[fieldName][0] as ValidateError).message;
      if (errorMessage) {
        notityErrorMsg(toast, errorMessage);
      }
    }
  });
  return get(pass);
};
const pass = ref(false);
const errorFields = ref<Record<string, ValidateError[]>>({});
const errors = ref<ValidateError[]>([]);

const watchField = (fieldName: string) => {
  watch(
    () => form[`${props["name"]}_${fieldName}`],
    async (newVal, oldVal) => {
      if (fieldName == "off") {
        set(pass, true);
        emits("validateFn", get(pass));
      } else {
        const checkValidate = await validate(fieldName);
        if (!checkValidate) {
          set(form, `${props["name"]}_${fieldName}`, oldVal);
        }
        emits("validateFn", get(pass));
      }
    }
  );
};
watchField("off");
watchField("morning_start");
watchField("morning_end");
watchField("afternoon_start");
watchField("afternoon_end");
watchField("morning_start_minute");
watchField("morning_end_minute");
watchField("afternoon_start_minute");
watchField("afternoon_end_minute");

watch(formDataInit, newFormDataInit => {
  Object.assign(form, newFormDataInit);
});

const getDateData = () => {
  return get(form);
};

expose({
  getDateData,
});

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(get)(_unref(dayOfWeek)[props["name"]])) + ": ", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Dropdown, {
                    modelValue: form[props['name'] + '_morning_start'],
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form[props['name'] + '_morning_start']) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.startTimeMorning }]),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (validate('startTimeMorning')))
                  }, null, 8, ["modelValue", "options", "class"]),
                  _hoisted_10,
                  _createVNode(_component_Dropdown, {
                    modelValue: morningStartMinute.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((morningStartMinute).value = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    placeholder: "",
                    class: "shadow-none"
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_11,
                  _createVNode(_component_Dropdown, {
                    modelValue: form[props['name'] + '_morning_end'],
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form[props['name'] + '_morning_end']) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.endTimeMorning }]),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (validate('endTimeMorning')))
                  }, null, 8, ["modelValue", "options", "class"]),
                  _hoisted_12,
                  _createVNode(_component_Dropdown, {
                    modelValue: morningEndMinute.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((morningEndMinute).value = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    placeholder: "",
                    class: "shadow-none"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Dropdown, {
                    modelValue: form[props['name'] + '_afternoon_start'],
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form[props['name'] + '_afternoon_start']) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.startTimeAfterNoon }]),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (validate('startTimeAfterNoon')))
                  }, null, 8, ["modelValue", "options", "class"]),
                  _hoisted_16,
                  _createVNode(_component_Dropdown, {
                    modelValue: afternoonStartMinute.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((afternoonStartMinute).value = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    placeholder: "",
                    class: "shadow-none"
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_17,
                  _createVNode(_component_Dropdown, {
                    modelValue: form[props['name'] + '_afternoon_end'],
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form[props['name'] + '_afternoon_end']) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.endTimeAfterNoon }]),
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (validate('endTimeAfterNoon')))
                  }, null, 8, ["modelValue", "options", "class"]),
                  _hoisted_18,
                  _createVNode(_component_Dropdown, {
                    modelValue: afternoonEndMinute.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((afternoonEndMinute).value = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    placeholder: "",
                    class: "shadow-none"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ], 512), [
            [_vShow, !form[props['name'] + '_off']]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col", { 'ml-5': !form[props['name'] + '_off'] }])
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Checkbox, {
                  modelValue: form[props['name'] + '_off'],
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form[props['name'] + '_off']) = $event)),
                  inputId: "monday_afternoon_end",
                  id: "monday_afternoon_end",
                  name: "monday_afternoon_end",
                  class: "mr-2 checkbox",
                  value: true,
                  binary: true
                }, null, 8, ["modelValue"]),
                _hoisted_21
              ])
            ])
          ], 2)
        ])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})